import styles from "./StatusBadge.module.css";

type StatusBadgeProps = {
  label: string;
  tone: "accent" | "neutral" | "outline";
};

export const StatusBadge = ({ label, tone }: StatusBadgeProps) => (
  <span className={styles.badge} data-tone={tone}>
    {label}
  </span>
);
